import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'm14.534 13.465-3.86-3.86a5.143 5.143 0 0 0 1.05-3.12 5.235 5.235 0 1 0-5.24 5.23 5.172 5.172 0 0 0 3.13-1.05l3.86 3.86a.748.748 0 0 0 1.06 0 .754.754 0 0 0 0-1.06Zm-11.78-6.98a3.735 3.735 0 1 1 3.73 3.73 3.745 3.745 0 0 1-3.73-3.73Zm5.733.748h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5Z';
const draw24px = 'M20.314,19.256l-5.32-5.33a6.649,6.649,0,0,0,1.48-4.2A6.762,6.762,0,1,0,13.934,15l5.32,5.32a.748.748,0,0,0,1.06,0A.754.754,0,0,0,20.314,19.256ZM4.474,9.726a5.25,5.25,0,1,1,5.25,5.25A5.256,5.256,0,0,1,4.474,9.726Zm8.249.747h-6a.75.75,0,0,1,0-1.5h6a.75.75,0,0,1,0,1.5Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const MagnifyingGlassMinusIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'magnifyingGlassMinus'));
MagnifyingGlassMinusIcon.displayName = 'MagnifyingGlassMinusIcon';
MagnifyingGlassMinusIcon.propTypes = Icon.propTypes;
MagnifyingGlassMinusIcon.renderIcon = props => /*#__PURE__*/React.createElement(MagnifyingGlassMinusIcon, props);
export default MagnifyingGlassMinusIcon;
//# sourceMappingURL=MagnifyingGlassMinusIcon.js.map